
<template>
  <div class="container-fluid">
    <div class="panel panel-info">
      <!-- <div class="p-3 mb-2">
        <h5 style="text-align: left">
          <b-button class="float-right" variant="primary" @click="handleBack()"
           <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill >Back</b-button
          >
        </h5> -->
          <div class="p-3 mb-2 col-12">
    <h5>My Profile:
     <b-btn
          class="btn-danger float-right"
           style="text-align: right;"
          @click="handleBack()"
        >
         <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill> Back
        </b-btn></h5>
      </div>
        <hr />
        <b-form @submit.stop.prevent>
          <div class="form-group row">
            <label
              for="staticEmail"
              class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 col-form-label"
              >Name:</label
            >
            <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
              <b-form-input
                id="input-small"
                size="sm"
                placeholder=""
                value="Mr. Mangesh Sawant"
              ></b-form-input>
            </div>
          </div>
          <div class="form-group row">
            <label
              for="staticEmail"
              class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 col-form-label"
              >Address:</label
            >
            <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
              <b-form-input
                id="input-small"
                size="sm"
                placeholder=""
                value="Mu. Po. Belavandi , Taluka : Shirur , Dist: Pune "
              ></b-form-input>
            </div>
          </div>
          <div class="form-group row">
            <label
              for="staticEmail"
              class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 col-form-label"
              >Pincode:</label
            >
            <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
              <b-form-input
                id="input-small"
                size="sm"
                placeholder=""
                value="410202"
              ></b-form-input>
            </div>
          </div>
          <div class="form-group row">
            <label
              for="staticEmail"
              class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 col-form-label"
              >Contact:</label
            >
            <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
              <b-form-input
                id="input-small"
                value="+91 9920202020"
                size="sm"
                placeholder=""
              ></b-form-input>
            </div>
          </div>
          <div class="form-group row">
            <label
              for="staticEmail"
              class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 col-form-label"
              >Email:</label
            >
            <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
              <b-form-input
                id="input-small"
                value="dattatray.kharat@ceristechsolutions.com"
                size="sm"
                placeholder=""
              ></b-form-input>
            </div>
          </div>
          <div class="form-group row">
            <label
              for="staticEmail"
              class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 col-form-label"
              >Education:</label
            >
            <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
              <b-form-input
                id="input-small"
                size="sm"
                placeholder=""
                value="B.Com"
              ></b-form-input>
            </div>
          </div>
          <div class="form-group row">
            <label
              for="staticEmail"
              class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 col-form-label"
              >Village/city:</label
            >
            <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
              <b-form-input
                id="input-small"
                value="Inamgaon"
                size="sm"
                placeholder=""
              ></b-form-input>
            </div>
          </div>
          <hr />
          <div class="col-md-12">
            <center>
              <b-button variant="success" @click="send_enquiry1()">Update</b-button
              >&nbsp;
              
            </center>
          </div>
          <br />
        </b-form>
      </div>
    </div>
 
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    handleBack() {
      this.$router.go(-1);
    },
    send_enquiry1() {
      alert("update sucessfully ");
    },
  },
};
</script>
